const state = {
    subCategoriesProducts: [],
    categoriesProducts: [],
    monetizationTypes:[],
    companiesById: null,
    functionalities: [],
    companyTypeId:[],
    companyDemoTypes: [],
    loading: false,
    companies: [],
};

export default state;